import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-deanacademic',
  templateUrl: './deanacademic.component.html',
  styleUrls: ['./deanacademic.component.scss']
})
export class DeanacademicComponent implements OnInit {

  constructor( private meta: Meta,
               private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Pro-Vice Chancellor: Driving Academic Innovation');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI’s Pro-Vice Chancellor's role in advancing academic excellence, innovation, and strategic growth for a brighter educational future.`
        });
    }

}
